module.exports = __webpack_public_path__ + "img/menu_tr.c70fab81.png";